import { FingerprintProvider } from 'Context';
import { UISpriteProvider } from 'UIShared';
import { Routes } from './routes';
import { ConfirmModalProvider } from './UI/components/ConfirmModal';
function App() {
  return (
    <>
      <UISpriteProvider>
        <FingerprintProvider>
          <ConfirmModalProvider>
            <Routes />
          </ConfirmModalProvider>
        </FingerprintProvider>
      </UISpriteProvider>
      <div id="places" />
    </>
  );
}

export default App;
